import Pagination from '@mui/material/Pagination';
import { PropTypes } from 'prop-types';

const PaginationComponent = props => {
  const { count, numberOfRowsPerPage, onPageClick, page } = props;
  const pagecount = Math.ceil(count / numberOfRowsPerPage);
  const pageNumber = page + 1;
  return (
    <Pagination 
      data-testid="pagination"
      count={pagecount}
      page={pageNumber}
      size="medium"
      color="primary"
      style={{ display: 'flex', justifyContent: 'center' }}
      onChange={(event, value) => {
        onPageClick(value);
      }}
    />
  );
};

PaginationComponent.propTypes = {
  setPageNumber: PropTypes.func,
  numberOfRowsPerPage: PropTypes.number,
  datalength: PropTypes.number,
};
export default PaginationComponent;
